import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getFullBalance } from '../../services/ExchangeService';
import { PrivatePageLayout, PageHeader, PageTableCard } from '../../components/PrivatePage';
import SpotFuturesToggle from '../../components/SpotFuturesToggle/SpotFuturesToggle';
import WalletRow from './WalletRow';
import Toast from '../../components/Toast/Toast';
import NewOrderModal from '../../components/NewOrder/NewOrderModal';
import NewOrderButton from '../../components/NewOrder/NewOrderButton';
import SelectFiat, { setDefaultFiat, getDefaultFiat } from '../../components/SelectFiat/SelectFiat';

function Wallet() {
    const history = useHistory();

    const [balances, setBalances] = useState([]);
    const [fiat, setFiat] = useState(getDefaultFiat());
    const [totalFiat, setTotalFiat] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showSpot, setShowSpot] = useState(true); // New state for spot data
    const [showFuture, setShowFuture] = useState(false); // New state for future data

    const [notification, setNotification] = useState({ type: '', text: '' });

    useEffect(() => {
        if (!fiat) return;

        setIsLoading(true);
        getFullBalance(fiat, showFuture)
            .then((info) => {
                const balances = Object.entries(info).map(item => {
                    return {
                        symbol: item[0],
                        available: item[1].available,
                        onOrder: item[1].onOrder,
                        fiatEstimate: item[1].fiatEstimate,
                        avg: item[1].avg
                    }
                })
                    .sort((a, b) => {
                        if (a.symbol > b.symbol) return 1;
                        if (a.symbol < b.symbol) return -1;
                        return 0;
                    });

                setBalances(balances.filter(b => (showSpot && parseFloat(b.available) > 0) || (showFuture && parseFloat(b.onOrder) > 0)));
                setTotalFiat(info.fiatEstimate);
                setIsLoading(false);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message)
                setNotification({ type: 'error', text: err.response ? err.response.data : err.message });
                setIsLoading(false);
            })
    }, [fiat, showFuture, showSpot])

    function onOrderSubmit(order) {
        history.go(0);
    }

    function onFiatChange(event) {
        setDefaultFiat(event.target.value);
        setFiat(event.target.value);
    }

    const headerActions = (
        <>
            {localStorage.getItem("hasFutures") === "true" ? (
                <SpotFuturesToggle
                    value={showFuture ? 'futures' : 'spot'}
                    onChange={(market) => {
                        setShowSpot(market === 'spot');
                        setShowFuture(market === 'futures');
                    }}
                />
            ) : null}
            <SelectFiat onChange={onFiatChange} fiat={fiat} />
            <NewOrderButton />
        </>
    );

    return (
        <React.Fragment>
            <PrivatePageLayout>
                <PageHeader
                    eyebrow="Trading"
                    title="Wallet"
                    subtitle="View balances across spot and futures accounts."
                    actions={headerActions}
                />
                <PageTableCard>
                    <div className="table-wrapper table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="border-gray-200">Symbol</th>
                                    <th className="border-gray-200">Available</th>
                                    <th className="border-gray-200">Locked</th>
                                    <th className="border-gray-200">Fiat Total</th>
                                    <th className="border-gray-200">Avg Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading && balances && balances.length
                                    ? balances
                                        .filter((b) => parseFloat(b.available) > 0 || parseFloat(b.onOrder) > 0)
                                        .map((item) => (<WalletRow key={item.symbol} data={item} />))
                                    : (
                                        <tr>
                                            <td colSpan={5}>Loading...</td>
                                        </tr>
                                    )}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{totalFiat}</td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </PageTableCard>
            </PrivatePageLayout>
            <NewOrderModal onSubmit={onOrderSubmit} />
            <Toast type={notification.type} text={notification.text} />
        </React.Fragment>
    );
}

export default Wallet;
